export const languageOptions = [
  { value: 0, label: "EN", id: 0 },
  { value: 1, label: "AL", id: 1 },
];

// header translations
export const navBarLabels = [
  { id: 0, labels: ["Home", "Tours", "About Us", "Contacts"] },
  { id: 1, labels: ["Kreu", "Turet", "Rreth Nesh", "Kontakte"] },
];

// button translations
export const bookLabel = [
  { id: 0, label: "Book Now" },
  { id: 1, label: "Rezervo Tani" },
];

// banner translations

export const bannerLabel = [
  {
    id: 0,
    label: "Disvover the authentic Shkoder",
  },
  {
    id: 1,
    label: "Zbuloni Shkodrën autentike",
  },
];

export const bannerDescriptionLabel = [
  {
    id: 0,
    label: "Local experiences, stunning landscapes and unfergettable memories.",
  },
  {
    id: 1,
    label:
      "Eksperienca lokale, landscape të mrekullueshme dhe kujdeshe të padisputshme.",
  },
];

export const bannerTitleLabel = [
  {
    id: 0,
    label: "Discover the authentic Shkoder",
  },
  {
    id: 1,
    label: "Zbuloni Shkodrën autentike",
  },
];

export const bannerSubTitleLabel = [
  {
    id: 0,
    label: "Local experiences, stunning landscapes and unforgettable memories.",
  },
  {
    id: 1,
    label:
      "Eksperienca lokale, landscape të mrekullueshme dhe kujdeshe të padisputshme.",
  },
];

// why us translations

export const whyUsLable = [
  {
    id: 0,
    label: "WHY CHOOSE US",
  },
  {
    id: 1,
    label: "PSE NA ZGJODHET",
  },
];

export const whyUsTitle = [
  {
    id: 0,
    label: "Local. Authentic. Memorable.",
  },
  {
    id: 1,
    label: "Local. Authentic. Memorable.",
  },
];
export const whyUsDescription = [
  {
    id: 0,
    label:
      "We are locals who love our city and want to share it with you in the most authentic way.",
  },
  {
    id: 1,
    label: "Local. Authentic. Memorable.",
  },
];

// footer translations
export const contactUsLabel = [
  {
    id: 0,
    label: "Contact Us",
  },
  { id: 1, label: "Na Kontaktoni" },
];

export const footerDescriptionLabel = [
  {
    id: 0,
    label: "Your trusted guide to explore Shkoder and its surroundings.",
  },
  {
    id: 1,
    label:
      "Jemi lokaltë që i dashurojmë qytetin tonë dhe duam ta ndajm ë me ju në mënyrën më autentike.",
  },
];

// package tour translations

export const ourExperiencesLabel = [
  {
    id: 0,
    label: "Our Experiences",
  },
  { id: 1, label: "Eksperiencat Tona" },
];

export const chooseYourAventureLabel = [
  {
    id: 0,
    label: "Choose Your Adventure",
  },
  { id: 1, label: "Zgjidh Aventurën Tënde" },
];

export const packageDescriptionLabel = [
  {
    id: 0,
    label:
      "Handpicked experiences that show you the best of Shkoder, Book easily and enjoy an unforgettable journey.",
  },
  {
    id: 1,
    label:
      "Eksperienca të përzgjedhura që ju tregojnë më të mirën e Shkodrës, Rezervoni lehtësisht dhe shijoni një udhëtim të paharrueshëm.",
  },
];

// contact page translations

export const contactUsDescriptionLabel = [
  {
    id: 0,
    label:
      "We'd love to hear from you! Get in touch and we'll help you plan your perfect trip to Shkoder.",
  },
  {
    id: 1,
    label:
      "Do të na pëlqente të dëgjonim nga ju! Na kontaktoni dhe ne do t'ju ndihmojmë të planifikoni udhëtimin tuaj perfekt në Shkodër.",
  },
];

export const sendUsAMessageLabel = [
  {
    id: 0,
    label: "Send Us a Message",
  },
  {
    id: 1,
    label: "Na Dërgoni Një Mesazh",
  },
];

export const contactInformationLabel = [
  {
    id: 0,
    label: "Contact Information",
  },
  {
    id: 1,
    label: "Informacion Kontakti",
  },
];

// about us page translations

export const aboutUsLabel = [
  {
    id: 0,
    label: "About Us",
  },
  {
    id: 1,
    label: "Rreth Nesh",
  },
];

export const aboutUsDescriptionLabel = [
  {
    id: 0,
    label:
      "We are locals who love our city and want to share it with you in the most authentic way. Our idea was simple: create authentic enogastronomic experiences that let people explore the city in a fun and memorable way.",
  },
  {
    id: 1,
    label:
      "Jemi lokaltë që i dashurojmë qytetin tonë dhe duam ta ndajmë me ju në mënyrën më autentike. Ideja jonë ishte e thjeshtë: të krijojmë përvoja autentike enogastronomike që lejojnë njerëzit të eksplorojnë qytetin në një mënyrë argëtuese dhe të paharrueshme.",
  },
];

export const ourStoryLabel = [
  {
    id: 0,
    label: "Our Story",
  },
  {
    id: 1,
    label: "Historia Jonë",
  },
];

export const ourStoryDescriptionLabel = [
  {
    id: 0,

    label: `Created by friendship and brought together by our love for wine, food, travel, and good company. Our idea was simple: create authentic enogastronomic experiences that let people explore the city in a fun and memorable way.`,
  },
  {
    id: 1,
    label: `Krijuar nga miqësia dhe bashkuar nga dashuria jonë për verën, ushqimin, udhëtimet dhe shoqërinë e mirë. Ideja jonë ishte e thjeshtë: të krijojmë përvoja autentike enogastronomike që lejojnë njerëzit të eksplorojnë qytetin në një mënyrë argëtuese dhe të paharrueshme.`,
  },
];

export const promiseDescriptionLabel = [
  {
    id: 0,
    label: `We focus on authentic experiences, trusted local guidance, and
            memorable adventures that help you truly discover the beauty and
            culture of Shkoder.`,
  },
  {
    id: 1,
    label: `Ne fokusohemi në përvoja autentike, udhëzime lokale të besueshme dhe
            aventura të paharrueshme që ju ndihmojnë të zbuloni vërtet bukurinë dhe 
            kulturën e Shkodrës.`,
  },
];

export const ourPromiseLabel = [
  {
    id: 0,
    label: "Our Promise",
  },
  {
    id: 1,
    label: "Premtimi Jonë",
  },
];

export const aboutUsTitleIconPeopleLabel = [
  {
    id: 0,
    label: "Our guides are locals who know Shkoder like back of their hand.",
  },
  {
    id: 1,
    label: "Our guides are locals who know Shkoder like back of their hand.",
  },
];
export const aboutUsTitleIconPeopleTitleLabel = [
  {
    id: 0,
    label: "Local Guides",
  },
  {
    id: 1,
    label: "Local Guides",
  },
];

export const aboutUsTitleIconLocationLabel = [
  {
    id: 0,
    label: "We show you the real Shkoder, beyond the tourist spots.",
  },
  {
    id: 1,
    label: "Ne ju tregojmë Shkodrën e vërtetë, përtej vendeve turistike.",
  },
];
export const aboutUsTitleIconLocationTitleLabel = [
  {
    id: 0,
    label: "Authentic Experiences",
  },
  {
    id: 1,
    label: "Eksperienca Autentike",
  },
];

export const aboutUsTitleIconSecurityLabel = [
  {
    id: 0,
    label: "High-quality experiences at far and transparent prices.",
  },
  {
    id: 1,
    label:
      "Eksperienca të cilësisë së lartë me çmime të drejta dhe transparente.",
  },
];
export const aboutUsTitleIconSecurityTitleLabel = [
  {
    id: 0,
    label: "Best Price Guarantee",
  },
  {
    id: 1,
    label: "Garancia e Çmimit të Mëtë",
  },
];

export const aboutUsTitleIconHeartLabel = [
  {
    id: 0,
    label: "We support local communities and sustainable tourism.",
  },
  {
    id: 1,
    label: "Ne mbështesim komunitetet lokale dhe turizmin e durueshëm.",
  },
];
export const aboutUsTitleIconHeartTitleLabel = [
  {
    id: 0,
    label: "Responsible Travel",
  },
  {
    id: 1,
    label: "Udhëtim i Përgjegjshëm",
  },
];

export const whyTravelWithUsLabel = [
  {
    id: 0,
    label: "Why travel with us?",
  },
  {
    id: 1,
    label: "Why travel with us?",
  },
];
